import React from 'react';
import PropTypes from 'prop-types';
import ActivityInformation from '../../tmCommon/components/ActivityInformation';
import {
  ACTIVITY_INFORMATION_GS_QUERY,
  ACTIVITY_INFORMATION_WIDGET_SETTINGS,
  SMARTASSESSMENT_ACTIVITY_INFORMATION_DOWNLOAD
} from './constant';

const ActivityInformationTab = ({
  alertId,
  isSmartAssessment,
  isPrevention,
  onActivityDownloadComplete,
  module
}) => (
  <ActivityInformation
    showWidgetActionLabels={true}
    settings={ACTIVITY_INFORMATION_WIDGET_SETTINGS}
    alertId={alertId}
    gsQuery={ACTIVITY_INFORMATION_GS_QUERY}
    /* FIN-11305 (P4): enable Triggered Only switch on Activity tab — parallel
       to the Transactions tab. The switch component, state, and
       onChangeWidgetAction plumbing already exist in
       ActivityInfoFilters.js + ActivityInformation.js from B3. */
    hasTriggeredOnlySwitch={true}
    requireTriggeredOnlyParam={false}
    csvHeaders={SMARTASSESSMENT_ACTIVITY_INFORMATION_DOWNLOAD}
    isSmartAssessment={isSmartAssessment}
    isPrevention={isPrevention}
    onDownloadComplete={onActivityDownloadComplete}
    module={module}
  />
);

ActivityInformationTab.propTypes = {
  alertId: PropTypes.string.isRequired,
  isSmartAssessment: PropTypes.bool,
  isPrevention: PropTypes.bool,
  // FIN-11649: SmartAssessment passes a setter that bumps refreshKey — when a
  // synchronous Activity download dispatches, the Download History badge / list
  // re-fetches even before the BE async-flow lands.
  onActivityDownloadComplete: PropTypes.func,
  // FIN-13618 — async-download module; undefined keeps ActivityInformation's default.
  module: PropTypes.string
};

export default ActivityInformationTab;
